'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _baseAdapter = require('./base-adapter');

var _baseAdapter2 = _interopRequireDefault(_baseAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeltaAdapter = function (_BaseAdapter) {
    (0, _inherits3.default)(DeltaAdapter, _BaseAdapter);

    function DeltaAdapter() {
        (0, _classCallCheck3.default)(this, DeltaAdapter);
        return (0, _possibleConstructorReturn3.default)(this, (DeltaAdapter.__proto__ || (0, _getPrototypeOf2.default)(DeltaAdapter)).apply(this, arguments));
    }

    (0, _createClass3.default)(DeltaAdapter, [{
        key: 'read',


        /**
         *  @param {Object}   delta    - A Gun node
         *  @param {Function} callback - Call once read finished
         */
        value: function read(result, done) {
            done(null, result);
        }

        /**
         *  @param {Object}   delta    - A delta for the current node
         *  @param {Function} callback - Called once write finished
         */

    }, {
        key: 'write',
        value: function write(delta, done) {
            this._put(delta, done);
        }
    }]);
    return DeltaAdapter;
}(_baseAdapter2.default);

exports.default = DeltaAdapter;